const Unauthorized: React.FC = () => {
  return <div style={{ padding: "10px" }}>Unauthorized</div>;
};

export default Unauthorized;
